<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div
      class="row"
      v-else-if="!this.loading && !this.errormessage && this.links.length > 0"
    >
      <div
        class="col-lg-4 col-md-6 col-sm-12"
        v-for="link in links"
        :key="link.Id"
      >
        <card
          header-tag="header"
          class="m-2 "
        >
          <div
            class="image"
            style="
              background-color: #252b30;
              border-radius: 12px 12px 0 0;
              height: 40px;
            "
          >
            <h5 class="mb-0 text-center text-danger">
              {{ link.Headline }}
            </h5>
          </div>
          <div class="card-body">
            <div>{{ link.Description }}</div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <a
                :href="link.LinkUrl"
                target="_blank"
              >
                <p-button
                  type="default"
                  round
                  outline
                >{{ link.FileName ? 'Download' : 'Go' }}</p-button>
              </a>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div v-else>
      There are currently no Links to show you.
    </div>
  </div>
</template>

<script>
import linksApi from '@/services/api/links'
import oops from '@/components/_main/oops.vue'

export default {
  name: 'Links',
  components: {
    oops
  },
  data: function () {
    return {
      links: null,
      loading: true,
      errormessage: null
    }
  },
  mounted () {
    linksApi.get(this.$root.courseKey)
      .then(x => {
        this.links = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
